var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgConfigure = function SvgConfigure(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v20H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icons/loading",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#051275"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M3.902 16.093a.375.375 0 01.022-.549l.794-.8-.266-.266a.373.373 0 010-.527l.8-.793-.266-.266a1.869 1.869 0 010-2.644l1.321-1.314a.374.374 0 11.528-.528l.612.612 1.284-1.284a.55.55 0 01.776.777L8.224 9.793l2.334 2.335 1.282-1.29a.544.544 0 01.758.013.553.553 0 01.014.764l-1.279 1.287.261.268a.374.374 0 11-.528.527l-1.325 1.325a1.871 1.871 0 01-2.645 0l-.266-.266-.794.793a.374.374 0 01-.527 0l-.266-.266-.794.793a.372.372 0 01-.27.13h-.013a.375.375 0 01-.264-.113zm10.253-5.059a.4.4 0 01-.27-.133l-.27-.31-4.289-4.298v.042l-.27-.272a.385.385 0 01.02-.52.376.376 0 01.515-.02l1.073-1.013a1.887 1.887 0 012.683 0l.27.272.87-.877a.376.376 0 01.535 0l.27.272.535.54.27.268a.384.384 0 010 .54l-.869.877.27.272a1.927 1.927 0 010 2.707l-1.074 1.012a.384.384 0 010 .536.375.375 0 01-.259.1z",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfigure, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/configure.43963b32.svg";
export { ForwardRef as ReactComponent };